import { ApolloError } from "@apollo/client";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import useApplyErrorToForm from "~/modules/app/hooks/useApplyErrorToForm";

import FunctionTypeObservationTypeSelectElement from "../FunctionTypeObservationTypeSelectElement";

type Props = {
    onSubmit: (formInput: FunctionTypeObservationTypeFormInput) => void;
    isLoading?: boolean;
    researchTypeId: string;
    functionTypeId: string;
    error?: ApolloError;
};

export default function FunctionTypeObservationTypeForm({
    onSubmit,
    isLoading,
    researchTypeId,
    functionTypeId,
    error,
}: Props) {
    const { t } = useTranslation("functionType");

    const methods = useForm<FunctionTypeObservationTypeFormInput>({
        defaultValues: { observationTypeId: "" },
    });

    const {
        handleSubmit,
        setError,
        formState: { errors, isDirty, isSubmitting, isValid },
    } = methods;

    useApplyErrorToForm(error, setError);

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack gap={2} sx={{ width: "400px" }}>
                    {errors.root && (
                        <Alert severity="error">
                            <Typography>{errors.root.message}</Typography>
                        </Alert>
                    )}
                    <FunctionTypeObservationTypeSelectElement
                        researchTypeId={researchTypeId}
                        ecologicalFunctionTypeId={functionTypeId}
                    />
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={!isDirty || !isValid || isSubmitting || isLoading}
                        loading={isSubmitting || isLoading}
                    >
                        {t("functionTypeObservationTypeForm.btnSubmit")}
                    </Button>
                </Stack>
            </form>
        </FormProvider>
    );
}

export type FunctionTypeObservationTypeFormInput = {
    observationTypeId: string;
};
